import { fetchBookings, selectBookingsFirstLoad, selectCurrentPage } from "@/entities/booking";
import { useAppSelector, useAppDispatch } from "@/shared/lib/redux";
import { PageSubtitle } from "@/shared/ui/page-subtitle";
import { PageHeader } from "@/widgets/page-header";
import { useRef, useEffect } from "react";
import { BookingsList } from "./bookings-list";
import { fetchAirlines, selectAirlinesFirstLoad } from "@/entities/aviabooking-reference";
import { BookingPaymentModal, BookingTicketsModal, CancelBookingModal } from "@/features/booking-payment";
import { AcknowledgePriceChangeModal } from "@/features/booking-payment/ui/acknowledge-price-change-modal";

export const AviabookingBookingsPage = () => {
    const isFirstRender = useRef(true)
    const page = useAppSelector(selectCurrentPage)
    const bookingsFirstLoad = useAppSelector(selectBookingsFirstLoad)
    const airlinesFirstLoad = useAppSelector(selectAirlinesFirstLoad)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchBookings())
        }
    }, [page])

    useEffect(() => {
        if (bookingsFirstLoad) {
            dispatch(fetchBookings())
        }
        if (airlinesFirstLoad) {
            dispatch(fetchAirlines())
        }
        isFirstRender.current = false
    }, [])


    return (
        <div className="_page_container">
            <PageHeader title="Авиабилеты" />
            <div className='flexbox'>
                <PageSubtitle title="Список билетов" />
                <BookingsList />
            </div>
            <BookingPaymentModal/>
            <CancelBookingModal />
            <BookingTicketsModal />
            <AcknowledgePriceChangeModal />
        </div>
    )
}